import { useCallback, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";

import { isTodayDate, timezoneSelector, useFormats } from "@ryde/shared";

export const useUserActionsHistoryPlaqueDatetime = () => {
  const timezone = useRecoilValue(timezoneSelector);
  const { formatDateNormalized, formatTimeWithSecondsNormalized } =
    useFormats();

  return useCallback(
    (recordedAtMs: number): string => {
      const iso = new Date(recordedAtMs).toISOString() as TDateISO;
      const timeSs = formatTimeWithSecondsNormalized(iso);
      if (isTodayDate(iso, timezone)) {
        return timeSs;
      }
      return `${formatDateNormalized(iso)} ${timeSs}`;
    },
    [formatDateNormalized, formatTimeWithSecondsNormalized, timezone],
  );
};

export const useUserActionsHistoryPlaqueNowMs = () => {
  const [nowMs, setNowMs] = useState(0);

  useEffect(() => {
    setNowMs(Date.now());
  }, []);

  return nowMs;
};
